module.exports = __webpack_public_path__ + "img/icon03.b1050403.png";